var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    stroke: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4938 16.8882L24.4253 19.8197L27.3567 16.8882M12.6995 16.8882L9.76806 13.9568L6.83661 16.8882",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5411 23.3376C19.1711 24.0917 17.5924 24.3781 16.0448 24.1533C14.4972 23.9284 13.0653 23.2046 11.9666 22.0917C11.0034 21.1045 10.3353 19.8678 10.0374 18.5211C9.7396 17.1744 9.82396 15.7712 10.281 14.4699M13.6522 10.4392C15.0221 9.68502 16.6008 9.39861 18.1484 9.62347C19.696 9.84834 21.1279 10.5722 22.2266 11.6851C23.1898 12.6723 23.858 13.909 24.1558 15.2557C24.4536 16.6024 24.3693 18.0055 23.9122 19.3068",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C25.8366 33 33 25.8366 33 17C33 8.16344 25.8366 1 17 1C8.16344 1 1 8.16344 1 17C1 25.8366 8.16344 33 17 33Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9e4e09c5a8235ea44af8cd47006529ff.svg";
export { ForwardRef as ReactComponent };